import React from "react";
import { Link } from "react-router-dom";

export default function BreakingTicker({ articles }) {
  if (!articles || articles.length === 0) return null;
  const items = articles.slice(0, 6);
  return (
    <div className="flex items-stretch overflow-hidden border-b border-[var(--paper-border)] bg-white" data-testid="breaking-ticker">
      <div className="font-ui flex shrink-0 items-center bg-[var(--breaking)] px-4 text-xs font-bold uppercase tracking-wider text-white">
        Latest
      </div>
      <div className="no-scrollbar flex-1 overflow-hidden whitespace-nowrap py-2">
        <div className="marquee-track">
          {[...items, ...items].map((a, i) => (
            <Link
              key={i}
              to={`/article/${a.slug}`}
              className="font-serif-body mx-6 text-sm text-slate-700 hover:text-[var(--navy)]"
            >
              <span className="mr-2 text-[var(--gold)]">●</span>
              {a.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
